export { default } from '@material-ui/core/Toolbar';
